import React, { useEffect } from "react";
import { LegalLayout, LegalSection } from "../components/LegalLayout";
import { applyPageSeo } from "../lib/seo";

const ext = { target: "_blank", rel: "noopener noreferrer" };
const linkCls = "font-semibold text-brand-teal underline hover:text-brand-tealHover";

const DOCS = [
  {
    title: "Protocol Standard IVA Conditions — post April 2017",
    href: "/docs/A9023-FJ-Standard-Conditions-2017-version.pdf",
    description:
      "As agreed between Creditors and their voting agents, The Insolvency Service and Insolvency Practitioners. Applies to proposals submitted after 6th April 2017.",
  },
  {
    title: "Straightforward Consumer IVA Protocol 2016",
    href: "/docs/IVA-Protocol-2016-2016-version.pdf",
    description:
      "Applies to proposals submitted after 6th April 2017.",
  },
  {
    title: "Protocol Standard IVA Conditions — post July 2012",
    href: "/docs/ProtocolStandardConditions2012-2012-version.pdf",
    description:
      "As agreed between Creditors and their voting agents, The Insolvency Service and Insolvency Practitioners. Applies to proposals submitted after 1st July 2012.",
  },
  {
    title: "Protocol Standard IVA Conditions — post March 2008",
    href: "/docs/ProtocolStandardConditions-2008-version.pdf",
    description:
      "As agreed between Creditors and their voting agents, The Insolvency Service and Insolvency Practitioners. Applies to proposals submitted after 17th March 2008.",
  },
  {
    title: "Freeman Jones Standard IVA Conditions — post August 2007",
    href: "/docs/NewStandardConditions-2007-version.pdf",
    description:
      "Applies to IVAs arranged between 13th August 2007 and 16th March 2008.",
  },
  {
    title: "Original Standard IVA Conditions — prior to August 2007",
    href: "/docs/IVAStandardTCs-prior-to-2007.pdf",
    description:
      "Originally drawn up by the Association of Business Recovery Professionals (ABRP / R3). Applies to IVAs arranged prior to August 2007.",
  },
  {
    title: "Guide to Requisite Majorities (Rule 5.22 & Rule 5.23)",
    href: "/docs/Voluntary_arrangement_creditor_fee_guide_6_April_2017.pdf",
    description:
      "Rule 5.22 & Rule 5.23 explain the requisite majorities of votes needed for resolutions to be passed at a creditors meeting when considering an IVA in Northern Ireland and England & Wales respectively.",
  },
];

export const IvaStandardConditionsPage = () => {
  useEffect(() => {
    applyPageSeo({
      title: "Standard Conditions — IVA | Freeman Jones",
      description:
        "Download the Standard Conditions that form part of every Individual Voluntary Arrangement proposal put forward by Freeman Jones.",
      path: "/iva-standard-conditions",
    });
  }, []);

  return (
    <LegalLayout
      title="Standard Conditions — IVA"
      description="Download the Standard Conditions that form part of every IVA proposal put forward by Freeman Jones."
      path="/iva-standard-conditions"
      updated="2026"
      testid="iva-standard-conditions-page"
    >
      <LegalSection id="intro" title="About these documents">
        <p>
          There are Standard Conditions that make up part of every Individual Voluntary
          Arrangement (IVA) proposal put forward by our clients.
        </p>
        <p>
          We produce very high volumes of IVA proposals — creditors do not want to see a
          separate copy every time, so we make them available here instead. We will no longer
          send paper copies with our clients' IVA proposals, but we are happy to provide them
          upon request.
        </p>
        <p>
          The Standard Conditions have been developed and amended over time. The terms that
          apply to each IVA depend on when it was arranged.
        </p>
        <p>
          You may notice that in our version of the original conditions, some items in the index
          are noted as 'deleted'. This is because the provisions dealt with by that item are
          contained in the particular proposal for each client. More information about the
          Standard Conditions can be found on{" "}
          <a {...ext} href="https://www.r3.org.uk" className={linkCls}>
            R3's website
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection id="documents" title="Download documents">
        <ul className="space-y-6">
          {DOCS.map((doc) => (
            <li key={doc.href} className="border-b border-brand-border pb-6 last:border-0 last:pb-0">
              <a {...ext} href={doc.href} className={linkCls}>
                {doc.title}
              </a>
              <p className="mt-1 text-sm text-brand-body">{doc.description}</p>
            </li>
          ))}
        </ul>
      </LegalSection>
    </LegalLayout>
  );
};
